module.exports = __webpack_public_path__ + "static/media/7d05596a-3b5c-4663-849c-aa43ecdac9f2.e8f1c7f7.JPG";